import { headers, host } from "./shared";
import axios from "axios";
import type { AxiosResponse } from "axios";

import type { FeatureFlags } from "../../types/api";

export const getFeatureFlags = async (
  accessToken?: string | null,
): Promise<AxiosResponse<FeatureFlags>> => {
  return await axios.get(`${host}/api/features`, headers(accessToken));
};
